import http from '@shared/http';
import { COSMOS_V2_URL } from '@shared/const';

type LeadData = {
  name: string;
  phone: string;
  city: string;
  marketType: string;
  budget: string;
  community: string;
};

type GetReferredLeadsListResponse = {
  name: string;
  mobile: string;
  email: string;
  status: string;
  notes: string;
  market_type: string;
  city: string;
  created_at: string;
};
type ReferredLeadsListResponse = {
  leads: GetReferredLeadsListResponse[];
};

export const referAndEarnApi = {
  createLead: (body: LeadData) =>
    http.post(`${COSMOS_V2_URL}/leads/rebu/refer-lead`, {
      lead_name: body.name,
      lead_phone: body.phone,
      city: body.city,
      market_type: body.marketType,
      budget: body.budget,
      community: body.community,
    }),
  getReferredLeadsList: () =>
    http.get<ReferredLeadsListResponse>(`${COSMOS_V2_URL}/leads/rebu/refer-lead`),
};
